import { render, staticRenderFns } from "./ReChatSidebar.vue?vue&type=template&id=9b37cf26&scoped=true"
import script from "./ReChatSidebar.vue?vue&type=script&lang=js"
export * from "./ReChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./ReChatSidebar.vue?vue&type=style&index=0&id=9b37cf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b37cf26",
  null
  
)

export default component.exports